import React, { useState } from 'react';
import LogoSimpleBlack from './mobilelogoblack.png';
import './Login.css';

function Signin({ onToggle }) {
  const [correo, setCorreo] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [confirmarContrasena, setConfirmarContrasena] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const validarCorreo = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validarContrasena = (password) => /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/.test(password);

  const enviarDatos = async (event) => {
    event.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');

    if (!validarCorreo(correo)) {
      setErrorMessage('Ingresá un correo electrónico válido.');
      return;
    }

    if (contrasena !== confirmarContrasena) {
      setErrorMessage('Las contraseñas no coinciden.');
      return;
    }

    if (!validarContrasena(contrasena)) {
      setErrorMessage('La contraseña debe tener al menos 8 caracteres, una letra y un número.');
      return;
    }

    try {
      setLoading(true);
      const response = await fetch('/api/registro', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          correo,
          contraseña: contrasena,
        }),
        credentials: 'include',
      });

      if (response.ok) {
        setSuccessMessage('Te enviamos un correo para confirmar tu cuenta.');
        setCorreo('');
        setContrasena('');
        setConfirmarContrasena('');
        return;
      }

      if (response.status === 409) {
        setErrorMessage('Ese correo ya está registrado.');
        return;
      }

      const data = await response.json().catch(() => ({}));
      setErrorMessage(data.error || 'No pudimos crear la cuenta.');
    } catch (error) {
      console.error('Error en enviarDatos:', error);
      setErrorMessage('No pudimos conectar con el servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-panel">
      <img className="auth-logo" src={LogoSimpleBlack} alt="Cannubis" />
      <div className="auth-heading">
        <p className="auth-kicker">Nueva cuenta</p>
        <h1>Registrate</h1>
      </div>

      <form className="auth-form" onSubmit={enviarDatos}>
        <div className="form-group">
          <label htmlFor="signin-correo">Correo electrónico</label>
          <input
            autoComplete="email"
            id="signin-correo"
            name="correo"
            onChange={(e) => setCorreo(e.target.value)}
            required
            type="email"
            value={correo}
          />
        </div>
        <div className="form-group">
          <label htmlFor="signin-contrasena">Contraseña</label>
          <input
            autoComplete="new-password"
            id="signin-contrasena"
            name="contrasena"
            onChange={(e) => setContrasena(e.target.value)}
            required
            type="password"
            value={contrasena}
          />
        </div>
        <div className="form-group">
          <label htmlFor="confirmarContrasena">Confirmar contraseña</label>
          <input
            autoComplete="new-password"
            id="confirmarContrasena"
            name="confirmarContrasena"
            onChange={(e) => setConfirmarContrasena(e.target.value)}
            required
            type="password"
            value={confirmarContrasena}
          />
        </div>

        {errorMessage && <p className="auth-message error">{errorMessage}</p>}
        {successMessage && <p className="auth-message success">{successMessage}</p>}

        <button className="auth-submit" disabled={loading} type="submit">
          {loading ? 'Creando cuenta...' : 'Crear cuenta'}
        </button>
      </form>

      <div className="auth-links">
        <button type="button" onClick={onToggle}>Ya tengo cuenta</button>
      </div>
    </div>
  );
}

export default Signin;
